import React, { useState, createContext, useEffect } from "react";
import { useSessionStorage } from '../Hooks/useSessionStorage';



export const ProductContext = createContext()

export const ProductProvider = (props) => {

	
	const [activeStep, setActiveStep] = useState(1)
	const [generalPrices, setGeneralPrices] = useSessionStorage('no__generalprices', {})

	const [products, setProducts] = useSessionStorage({})
	const [taxonomies, setTaxonomies] = useSessionStorage('no__taxonomies', {})
	const [region, setRegion] = useSessionStorage('no__region', {
		region: '',
		slug: '',
		aufpreis: 0,
		id: 0
	})
	const [bestellung, setBestellung] = useSessionStorage('no__bestellung', {

		basePrice: 0,

		lieferstellen: {},
		anzahlLieferstellen: 1,
		liefergebiete: {},
		wunschtermin: {
			datum: false,
			value: 0,
			express: 0,
			uhrzeit: ''
		},
		aufpreis: 0,
		liefermenge: 500,
		lieferfahrzeug: ["Egal", 0],
		schlauch: ["bis 40 Meter", 0],
		plz: '',
		comment: '',
		settings: {
			aufschlag_lieferstelle: 0,
			aufschlag_wunschtermin: 0,
			kwk: '',
			vorfracht: 0,	
			lieferzeit_max: ''
		},
		telefon: '',
		email: '',
		contact: {
			main: {
				first: '',
				last: '',
				company: '',
				email: '',
				phone: '',
				street: '',
				street_number: '',
				city: '',
				plz: '',
				clientId: '',
				werberId: '',
				birthday: '',

				billing: {
					billing: false,
					first: '',
					last: '',
					company: '',
					email: '',
					phone: '',
					street: '',
					street_number: '',
					plz: '',
					city: ''
				},
				payment: {
					method: '',
					price: 0,
					clientId: false
				},
			},

		},
		totals: {
			allTotalNetto: 0,
			totalAmount: 500,
			totalNetto: 0,
			totalBrutto: 0,
			per100Netto: 0,
			termin: 0,
			schlauch: 0,
			marge: 0,
			lieferfahrzeug: 0,
			productName: '',
			productId: 0,
			productExtra: 0,
			wunschtermin: 0,
			express: 0,
			singleExpress: 0,
			lieferstelle: 0,
			bezahlaufschlag: 0,
		}

	})
	const [oelpreis, setOelpreis] = useState(0)
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [step, setStep] = useState(1)
	const [settings, setSettings] = useSessionStorage('no__settings', {})
	const [currentPlz, setCurrentPlz] = useSessionStorage('no__plz', bestellung.plz)


	const apiRoute = document.getElementById('nordoel_heizoel_app').dataset.pageurl


	// Heizölpreis laden
	useEffect(() => {
		let controller = new AbortController();
		const signal = controller.signal;
		(async () => {
			try {
				const res = await fetch(`${apiRoute}/wp-json/heizoelpreis/v1`, { signal })
				const price = await res.json()
				setOelpreis(parseFloat(price))
				controller = null
				return setLoading(false)
			} catch (e) { 
				console.error(e);
			}			
		})()
		return () => {
			controller?.abort();
		}
		// fetch(`${apiRoute}/wp-json/heizoelpreis/v1`)
		// 	.then(res => {
		// 		setOelpreis(parseFloat(res.json()))
		// 		return setLoading(false)
		// 	})
		// 	.catch(err => console.error({Ölpreis: err}))
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// Region laden
	useEffect(() => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [oelpreis])
	return (
		<ProductContext.Provider value={{
			products, setProducts,
			step, setStep,
			settings, setSettings,
			bestellung, setBestellung,
			region, setRegion,
			oelpreis,
			loading, setLoading,
			taxonomies, setTaxonomies,
			error, setError,
			activeStep, setActiveStep,
			generalPrices, setGeneralPrices,
			currentPlz, setCurrentPlz
		}}>
			{props.children}
		</ProductContext.Provider>
	)
}



